/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Ligne de la liste des commissions d'une garantie.
 * @export
 * @interface GarantieCommissionItemDto
 */
export interface GarantieCommissionItemDto {
    /**
     * 
     * @type {string}
     * @memberof GarantieCommissionItemDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GarantieCommissionItemDto
     */
    beneficiaire?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GarantieCommissionItemDto
     */
    typeCommission?: string | null;
}

/**
 * Check if a given object implements the GarantieCommissionItemDto interface.
 */
export function instanceOfGarantieCommissionItemDto(value: object): value is GarantieCommissionItemDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GarantieCommissionItemDtoFromJSON(json: any): GarantieCommissionItemDto {
    return GarantieCommissionItemDtoFromJSONTyped(json, false);
}

export function GarantieCommissionItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GarantieCommissionItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'beneficiaire': json['beneficiaire'] == null ? undefined : json['beneficiaire'],
        'typeCommission': json['typeCommission'] == null ? undefined : json['typeCommission'],
    };
}

export function GarantieCommissionItemDtoToJSON(json: any): GarantieCommissionItemDto {
    return GarantieCommissionItemDtoToJSONTyped(json, false);
}

export function GarantieCommissionItemDtoToJSONTyped(value?: GarantieCommissionItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'beneficiaire': value['beneficiaire'],
        'typeCommission': value['typeCommission'],
    };
}

